import { useToast, DEFAULT_TOAST_DURATION } from "@hooks/use-toast"
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastViewport,
  ToastProgress,
  ToastIcon,
} from "./toast"

function ToasterContent() {
  const { toasts } = useToast()

  return (
    <ToastProvider duration={DEFAULT_TOAST_DURATION}>
      {toasts.map(function ({
        id,
        title,
        description,
        action,
        variant,
        duration,
        ...props
      }) {
        const toastDuration = duration || DEFAULT_TOAST_DURATION

        return (
          <Toast
            key={id}
            variant={variant}
            toastDuration={toastDuration}
            duration={toastDuration}
            {...props}
          >
            <div className='flex w-full items-start gap-3'>
              <ToastIcon variant={variant} />
              <div className='grid flex-1 gap-1'>
                <ToastDescription>{description}</ToastDescription>
              </div>
            </div>
            {action}
            <ToastClose />
            <ToastProgress variant={variant} />
          </Toast>
        )
      })}
      <ToastViewport />
    </ToastProvider>
  )
}

export function Toaster() {
  return <ToasterContent />
}
